export const AR_SUMMARY_FIELDS = [
  {
    label: 'Company',
    field: 'companyName'
  },
  // {
  //   field: 'openBalance',
  //   label: 'Current',
  //   cell: 'formatMoney',
  //   sortable: true,
  //   hidden: false,
  // },
  // {
  //   field: 'creditBalance',
  //   label: 'Credit',
  //   cell: 'formatMoney'
  // },
  {
    field: 'currentBalance',
    label: 'Current',
    cell: 'formatMoney'
  },
  {
    field: 'oneToThirtyBalance',
    label: '1 - 30',
    cell: 'formatMoney'
  },
  {
    field: 'thirtyOneToSixtyBalance',
    label: '31 - 60',
    cell: 'formatMoney'
  },
  {
    field: 'sixtyOneToNinetyBalance',
    label: '61 - 90',
    cell: 'formatMoney'
  },
  {
    field: 'greaterThanNinetyBalance',
    label: '> 90',
    cell: 'formatMoney'
  },
  {
    field: 'totalBalance',
    label: 'TOTAL',
    cell: 'formatMoney'
  },
];

export const AR_DETAILS_FIELDS = [
  {
    label: 'Invoice Date',
    field: 'invoiceDate',
    cell: 'formatDate'
  },
  {
    field: 'invoiceNumber',
    label: 'Num'
  },
  {
    field: 'companyName',
    label: 'Company Name'
  },
  {
    label: 'DueDate',
    field: 'dueDate',
    cell: 'formatDate'
  },
  {
    field: 'amount',
    label: 'Amount',
    cell: 'formatMoney'
  },
  {
    field: 'openBalance',
    label: 'Open Balance',
    cell: 'formatMoney'

  },

]


export const AP_SUMMARY_FIELDS = [
  {
    label: 'Vendor',
    field: 'companyName'
  },
  {
    field: 'openBalance',
    label: 'Current',
    cell: 'formatMoney'
  },
  {
    field: 'creditBalance',
    label: 'Credit',
    cell: 'formatMoney'
  },
  {
    field: 'totalBalance',
    label: 'Total',
    cell: 'formatMoney'
  },
];

export const AP_DETAILS_FIELDS = [
  {
    label: 'Date',
    field: 'date',
    cell: 'formatDate'
  },
  {
    label: 'Transaction Type',
    field: 'transactionType'
  },  
  {
    field: 'number',
    label: 'Num',
  },
  {
    field: 'companyName',
    label: 'Vendor'
  },
  {
    label: 'Due Date',
    field: 'dueDate',
    cell: 'formatDate'
  },
  {
    key: 'Amount',
    field: 'amount',
    label: 'Amount',
    cell: 'formatMoney'
  },
  {
    field: 'openBalance',
    label: 'Open Balance',
    cell: 'formatMoney'
  },

]

export const INC_CUST_SUMMARY_FIELDS = [
  {
    label: 'Customer',
    field: 'companyName',
  },
  {
    field: 'balance',
    label: 'Balance',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
];

export const INC_CUST_DETAILS_FIELDS = [
    
  {
    field: 'companyName',
    label: 'Customer'
  },
  {
    field: 'dateCreated',
    label: 'Date',
    cell: 'formatDate'
  },
  {
    field: 'invoiceId',
    label: 'Num'
  },
  
  {
    field: 'memo',
    label: 'Memo',
  },
  {
    field: 'account',
    label: 'Account'
  },
  {
    field: 'balance',
    label: 'Balance',
    cell: 'formatMoney'
  },
  {
    field: 'amount',
    label: 'Amount',
    cell: 'formatMoney'
  },
]


export const EXP_VEND_SUMMARY_FIELDS = [
  {
    label: 'Vendor',
    field: 'companyName'
  },
  {
    field: 'balance',
    label: 'Balance',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
];

export const EXP_VEND_DETAILS_FIELDS = [
    
  {
    field: 'companyName',
    label: 'Vendor',
  },
  {
    field: 'dateCreated',
    label: 'Date',
    cell: 'formatDate'
  },
  {
    field: 'number',
    label: 'Num',
  },
  
  {
    field: 'memo',
    label: 'Memo'
  },
  {
    field: 'account',
    label: 'Account',
  },
  {
    field: 'balance',
    label: 'Balance',
    cell: 'formatMoney'
  },
  {
    field: 'amount',
    label: 'Amount',
    cell: 'formatMoney'
  },
]

export const CREDIT_MEMO_SUMMARY_FIELDS = [
  {
    label: 'Company',
    field: 'companyName'
  },
  {
    field: 'available',
    label: 'Available',
    cell: 'formatMoney'
  },
  {
    field: 'applied',
    label: 'Applied',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
];

export const CREDIT_MEMO_DETAILS_FIELDS = [
    
  {
    label: 'Company',
    field: 'companyName'
  },
  {
    label: 'Date',
    field: 'creditMemoDate',
    cell: 'formatDate'
  },
  {
    label: 'Source',
    field: 'creditMemoSource'
  },
  {
    label: 'Status',
    field: 'status'
  },
  {
    label: 'Number',
    field: 'number'
  },
  {
    label: 'Transaction',
    field: 'transaction'
  },
  {
    field: 'available',
    label: 'Available',
    cell: 'formatMoney'
  },
  {
    field: 'applied',
    label: 'Applied',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
]

export const INVENTORY_WORKSHEET_FIELDS = [
    
  {
    label: 'Part Number',
    field: 'partNumber'
  },
  {
    label: 'Item Description',
    field: 'categoryName'
  },
  {
    label: 'Mfr',
    field: 'manufacturerName'
  },
  {
    label: 'Bin',
    field: 'bin'
  },
  {
    label: 'On Hand',
    field: 'number'
  },
  {
    label: 'Physical Count'
  }
]

export const EMPLOYEE_SALES_COMMISSION_DETAILS_FIELDS = [
    
  {
    field: 'salesPersonName',
    label: 'Sales Person',
  },
  {
    field: 'invoiceNo',
    label: 'Invoice Number'
  },
  {
    field: 'invoiceDate',
    label: 'Invoice Date',
    cell: 'formatDate',
  },
  {
    field: 'companyName',
    label: 'Company'
  },
  {
    field: 'subTotal',
    label: 'Sub Total',
    cell: 'formatMoney'
  },
  {
    field: 'charges',
    label: 'Charges',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'itemCost',
    label: 'Item Cost',
    cell: 'formatMoney'
  },
  {
    field: 'expenses',
    label: 'Expenses',
    cell: 'formatMoney'
  },
  {
    field: 'profit',
    label: 'Profit',
    cell: 'formatMoney'
  },
  {
    field: 'margin',
    label: 'Margin',
    cell: 'formatPercentage'
  },
  {
    field: 'commission',
    label: 'Commission',
    cell: 'formatMoney'
  },
]